export default __webpack_public_path__ + "static/media/banner-learn-about-features.03ccf126.png";